const BLOCK_LENGTH = 5
const MARGIN = 4
const WHITE = 'rgb(255,255,255)'
const BLACK = 'rgb(0,0,0)'

/* flicker canvas */
export class FlickerRenderer {
  constructor(canvas) {
    this.code
    this.bitarray
    this.halfbyteid
    this.clock = 1
    this.ctx
    this.initCanvas(canvas)
  }

  initCanvas(canvas) {
    this.ctx = canvas.getContext('2d')
    this.ctx.imageSmoothingEnabled = false

    this.drawBackground()
  }

  step() {
    this.drawTriangles()

    const { width, height } = this.ctx.canvas

    const barwidth = Math.ceil(width / BLOCK_LENGTH)
    const offsetTop = 3 * MARGIN

    this.bitarray[this.halfbyteid][0] = this.clock

    for (let i = 0; i < BLOCK_LENGTH; i++) {
      if (this.bitarray[this.halfbyteid][i] === 1) {
        this.ctx.fillStyle = WHITE
      } else {
        this.ctx.fillStyle = BLACK
      }
      this.ctx.fillRect(i * barwidth + MARGIN, offsetTop, barwidth - 2 * MARGIN, height - offsetTop)
    }

    this.clock--
    if (this.clock < 0) {
      this.clock = 1

      this.halfbyteid++
      if (this.halfbyteid >= this.bitarray.length) {
        this.halfbyteid = 0
      }
    }

    return 0
  }

  setCode(newcode) {
    this.code = newcode.getCode()
    this.setup()
    this.reset()
  }

  drawBackground() {
    const { width, height } = this.ctx.canvas

    this.ctx.fillStyle = BLACK
    this.ctx.fillRect(0, 0, width, height)
  }

  drawTriangles() {
    const { width } = this.ctx.canvas

    const size = MARGIN * 3 - 2

    const barwidth = width / BLOCK_LENGTH
    const barCenterOffset = Math.ceil(barwidth / 2 - size / 2)

    this.drawTriangle(barCenterOffset, 0, size)
    this.drawTriangle(4 * barwidth + barCenterOffset, 0, size)
  }

  drawTriangle(x, y, scale) {
    this.ctx.beginPath()
    this.ctx.moveTo(x, y)
    this.ctx.lineTo(x + scale, y)
    this.ctx.lineTo(x + scale / 2, y + scale)

    this.ctx.fillStyle = WHITE
    this.ctx.fill()

    this.ctx.closePath()
  }

  reset() {
    this.halfbyteid = 0
    this.clock = 1
  }

  setup() {
    const bits = {
      '0': [0, 0, 0, 0, 0],
      '1': [0, 1, 0, 0, 0],
      '2': [0, 0, 1, 0, 0],
      '3': [0, 1, 1, 0, 0],
      '4': [0, 0, 0, 1, 0],
      '5': [0, 1, 0, 1, 0],
      '6': [0, 0, 1, 1, 0],
      '7': [0, 1, 1, 1, 0],
      '8': [0, 0, 0, 0, 1],
      '9': [0, 1, 0, 0, 1],
      A: [0, 0, 1, 0, 1],
      B: [0, 1, 1, 0, 1],
      C: [0, 0, 0, 1, 1],
      D: [0, 1, 0, 1, 1],
      E: [0, 0, 1, 1, 1],
      F: [0, 1, 1, 1, 1],
    }

    /* prepend synchronization identifier */
    this.code = '0FFF' + this.code

    this.bitarray = []
    for (let i = 0; i < this.code.length; i += 2) {
      this.bitarray[i] = bits[this.code[i + 1]]
      this.bitarray[i + 1] = bits[this.code[i]]
    }
  }
}
